var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-content',[_c('v-layout',{attrs:{"align-center":"","justify-center":"","column":"","fill-height":""}},_vm._l((_vm.CARDs),function(card,i){return _c('div',{key:i},[_c('CursoX',{attrs:{"datos":card}}),_c('br')],1)}),0)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }